import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetCohortExplorer = () => <DatasetPlaceholder label="Cohort Explorer" />;
